<template>
  <tr>
    <td v-for="header in headers" :key="header.text">
      <b :class="{'shadow': shadowTotalTitle}" v-if="header.value === options.totalCalculate.titleField">{{ fmt(rowData[header.value]) }}</b>
      <template v-else>{{ fmt(rowData[header.value]) }}</template>
    </td>
  </tr>
</template>

<script>
  export default {
    props: {
      rowData: Object,
      headers: Array,
      options: Object,
      shadowTotalTitle: {
        type: Boolean,
        default: false
      },
      fmt: {
        type: Function,
        default: v => v,
      },
    },
  }
</script>
<style lang="scss" scoped>
  .shadow {
    color: rgba(0, 0, 0, 0.3);
  }
</style>
